import axios from 'axios'
import store from '@/store'

export default {
  getRoles () {
    return new Promise((resolve, reject) => {
      axios.get('/api/roles').then(({ data }) => {
        store.dispatch('setRoles', data)
        resolve(true)
      }, error => {
        reject(error)
      })
    })
  }
}
